
interface Cache {
  cache: "no-store" | "default" | "force-cache" | "no-cache" | "only-if-cached" | "reload" | undefined
}

interface GetAuth {
  headers: {
    "userid": string,
    "role": string,
    "authorization": string,
  }
}

interface PutPostAuth {
  headers: {
    "userid": string,
    "role": string,
    "authorization": string,
    "content-type": "application/json"
  },
}

interface PutPost {
  method: 'PUT' | 'POST',
  headers: { "content-type": string; };
  body: any
}


interface Delete {
  method: 'DELETE'
}

type GetAuthAndCache = GetAuth & Cache
type PutPostAuthAndCache = PutPostAuth & PutPost & Cache
type DeleteAuthAndCache = Delete & GetAuth & Cache
type PutPostAndCache = PutPost & Cache


export const GetHeader = (userid: string, token: string, role: string): GetAuthAndCache => {
  return {
    headers: {
      "userid": userid,
      "role": role,
      "authorization": "Bearer " + token
    },
    cache: 'no-store',
  }
}

export const DeleteHeader = (userid: string, token: string, role: string): DeleteAuthAndCache => {
  return {
    headers: {
      "userid": userid,
      "role": role,
      "authorization": "Bearer " + token
    },
    cache: 'no-store',
    method: 'DELETE'
  }
}

export const PPHeader = (userid: string, token: string, role: string, body: any, method: 'PUT' | 'POST'): PutPostAuthAndCache => {
  if (method === 'PUT') {
    return {
      headers: {
        "userid": userid,
        "role": role,
        "authorization": "Bearer " + token,
        "content-type": "application/json"
      },
      cache: 'no-store',
      method: 'PUT',
      body: body
    }
  } else {
    return {
      headers: {
        "userid": userid,
        "role": role,
        "authorization": "Bearer " + token,
        "content-type": "application/json"
      },
      cache: 'no-store',
      method: 'POST',
      body: body
    }
  }
}

export const PPUnAuthHeader = (body: any, method: 'PUT' | 'POST'): PutPostAndCache => {
  if (method === 'PUT') {
    return {
      method: 'PUT',
      cache: 'no-store',
      headers: {
        "content-type": "application/json"
      },
      body: body
    }
  } else {
    return {
      method: 'POST',
      cache: 'no-store',
      headers: {
        "content-type": "application/json"
      },
      body: body
    }
  }

}

export const CacheHeader = (): Cache => {
  return {
    cache: 'no-store'
  }
}